import { Project, TFile } from '@brg/api';

/**
 * Получает изображения проекта в зависимости от языка
 */
export const getProjectImages = (project: any, lang: any): TFile[] => {
  if (lang === 'en' && project?.titleImages_en?.length) {
    return project?.titleImages_en;
  }
  if (lang === 'ru' && project?.titleImages?.length) {
    return project?.titleImages;
  }
  return project?.titleImages?.length ? project?.titleImages : project?.titleImages_en || [];
};

/**
 * Получает изображение проекта для отображения
 */
export const getProjectImage = (project: any) => {
  if (!project) return null;
  // Пытаемся получить titleImages
  const titleImages = project.titleImages || project.titleImages_en || [];
  if (titleImages.length > 0) {
    return titleImages[0];
  }
  return null;
};
import { Project, TFile } from '@brg/api';

/**
 * Получает изображения проекта в зависимости от языка
 */
export const getProjectImages = (project: any, lang: any): TFile[] => {
  if (lang === 'en' && project?.titleImages_en?.length) {
    return project?.titleImages_en;
  }
  if (lang === 'ru' && project?.titleImages?.length) {
    return project?.titleImages;
  }
  return project?.titleImages?.length ? project?.titleImages : project?.titleImages_en || [];
};

/**
 * Получает изображение проекта для отображения
 */
export const getProjectImage = (project: any) => {
  if (!project) return null;
  // Пытаемся получить titleImages
  const titleImages = project.titleImages || project.titleImages_en || [];
  if (titleImages.length > 0) {
    return titleImages[0];
  }
  return null;
};
